import React, { useEffect, useState } from "react";
import { collection, getDocs, doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../../firebaseConfig";

export default function RNBVerificationPanel() {
  const [apps, setApps] = useState([]);

  const fetchApps = async () => {
    const snap = await getDocs(collection(db, "office_scheme_applications"));
    setApps(
      snap.docs
        .map((d) => ({ id: d.id, ...d.data() }))
        .filter((a) => a.status === "RNB_PENDING")
    );
  };

  useEffect(() => {
    fetchApps();
  }, []);

  const approve = async (app) => {
    await updateDoc(doc(db, "office_scheme_applications", app.id), {
      status: "RNB_APPROVED",
      rnbApprovedAt: serverTimestamp(),
    });
    fetchApps();
  };

  return (
    <Panel title="R&B Verification Panel">
      {apps.length === 0 ? (
        <p>No R&B pending applications.</p>
      ) : (
        apps.map((app) => (
          <Card key={app.id} app={app} actionLabel="Approve R&B" onAction={() => approve(app)} />
        ))
      )}
    </Panel>
  );
}

function Panel({ title, children }) {
  return <div className="bg-white rounded-2xl shadow p-6"><h2 className="text-2xl font-bold mb-4">{title}</h2>{children}</div>;
}

function Card({ app, actionLabel, onAction }) {
  return (
    <div className="border rounded-xl p-4 mb-3">
      <h3 className="font-bold">{app.societyName}</h3>
      <p>{app.district} | {app.selectedDesign?.sizeLabel}</p>
      <button onClick={onAction} className="mt-3 bg-emerald-600 text-white px-4 py-2 rounded">{actionLabel}</button>
    </div>
  );
}